import { render } from "./StatementPage.vue?vue&type=template&id=1be83996&scoped=true"
import script from "./StatementPage.vue?vue&type=script&lang=js"
export * from "./StatementPage.vue?vue&type=script&lang=js"

import "./StatementPage.vue?vue&type=style&index=0&id=1be83996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be83996"]])

export default __exports__